<template>
  <div>
    <button
      type="button"
      class="border border-blue-600 text-sm font-medium p-2 my-2 mx-1 rounded-md shadow-sm text-blue-600 bg-gray-100 hover:bg-blue-600 hover:text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
      @click="actionSelected(params.options.updateAction)"
    >
      <PencilSquareIcon class="w-4 h-4" />
    </button>
    <button
      type="button"
      class="border border-red-600 text-sm font-medium p-2 my-2 mx-1 rounded-md shadow-sm text-red-600 bg-gray-100 hover:bg-red-600 hover:text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600"
      @click="actionSelected(params.options.deleteAction)"
    >
      <TrashIcon class="w-4 h-4" />
    </button>
  </div>
</template>

<script setup>
import { PencilSquareIcon, TrashIcon } from '@heroicons-2/vue/24/outline'

/**
 * @typedef {Object} ActionCellParams
 * @property {Array} options
 */
const props = defineProps({
  /** @type {LinkCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const actionSelected = (action) => {
  props.params.context.actionFunction(action, props.params.node.data)
}
</script>
